import { DataGrid } from "components/DataGrid/DataGrid";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";

import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toast } from "components/ToastShow/ToastAlert";
import { Attachment } from "pages/OfficeAutomation/Cartable/components/ActionList/components/Attachment/Attachment";
import { TREASURY_AND_ACCOUNTING_URL } from "utils/constants";
import { ENDPOINTSTREASURYANDACCOUNTING } from "utils/endpoints";
import { downloadCSV, getPageSize, trans } from "utils/helpers";
import { deleteReceipt, getReceipts } from "./api";
import { ReceiptForm } from "./ReceiptForm";
import { MessageType } from "types/enum";

interface Form {
  Title: string;
  Status: number;
}
export const Receipt = ({}: Form) => {
  const [response, setResponse] = useState<Response | any>(null);
  const [selectedObj, setSelectedObj] = useState<any>(null);
  const [mode, setMode] = useState("create");
  const [forceUpdate, setForceUpdate] = useState(false);
  const [resetForm, setResetForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageType, setMessageType] = useState<any>("info");
  const [orderBy, setOrderBy] = useState<any>([]);
  const [search, setSearch] = useState(null);
  const [showEventForm, setShowEventForm] = useState(false);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [pages, setPages] = useState<number>(0);
  const [filterlist, setFilterlist] = useState<any>("");
  const [showAttachment, setShowAttachment] = useState(false);

  const clickToolbarCallback = (clickedButtonName: string) => {
    switch (clickedButtonName.toLowerCase()) {
      case "print":
        alert("print ");
        break;
      case "excel":
        downloadCSV(response?.Data, 1, trans("Receipt"));
        break;
      case "refresh":
        setForceUpdate(!forceUpdate);
        break;
      case "create":
        handleCreateAction();
        break;
      case "view":
        if (selectedObj?.Id) handleViewRow();
        break;
      case "edit":
        if (selectedObj?.Id)
          selectedObj.SystemReserved
            // ? Toast(trans("Msg_CanNotEditSystemReservedData"), "error")
            ? Toast(trans("Msg_CanNotEditSystemReservedData"), MessageType.error)

            : handleEditRow();
        break;
      case "help":
        alert("call api help");
        break;
      case "remove":
        if (selectedObj?.Id)
          // Toast(
          //   trans("msg_deleteconfirm"),
          //   "warning",
          //   "alert",
          //   handleDeleteRow
          // );
          Toast(
            trans("msg_deleteconfirm"),
          MessageType.confirmDelete,
            handleDeleteRow
          );
        break;
      case "attach":
        if (selectedObj?.Id) {
          setMode("edit");
          setShowAttachment(true);
        } else {
          // Toast(trans("Msg_SelectRow"), "warning");
          Toast(trans("Msg_SelectRow"), MessageType.warning);

        }
        break;
    }
  };

  const handleChangePageSize = (e: any) => {
    setPageNum(1);
    setPageSize(e.currentTarget.value);
    getPageSize("Receipt", e.currentTarget.value);
    getReceiptsAsync(1);
  };

  const handleGoPage = (value) => {
    if (value) {
      if (value < 1 || value > pages) {
      } else setPageNum(+value);
      getReceiptsAsync(+value);
    } else {
    }
  };
  const handleNextPage = () => {
    if (pageNum < pages) {
      setPageNum(pageNum + 1);
      getReceiptsAsync(pageNum + 1);
    }
  };
  const handlePrevPage = () => {
    if (pageNum > 1) {
      setPageNum((pageNum) => {
        return +pageNum - 1;
      });
      getReceiptsAsync(pageNum - 1);
    }
  };
  const handleCreateAction = () => {
    // setSelectedObj(null)
    setMode("create");
    setShowEventForm(true);
  };
  const handleEditRow = () => {
    setMode("edit");
    setShowEventForm(true);
  };
  const handleDeleteRow = async () => {
    try {
      await deleteReceipt(selectedObj.Id);
      setForceUpdate(!forceUpdate);
    } catch (error) {}
  };
  const handleViewRow = () => {
    setMode("view");
    setShowEventForm(true);
  };

  const selectedObjCallback = (obj, index) => {
    setSelectedObj(obj);
  };
  const SearchHandler = (str) => {
    setPageNum(1);
    if (str == "") {
      setSearch(null);
    } else {
      setSearch(str);
    }
  };

  async function getReceiptsAsync(PageNum = pageNum) {
    setLoading(false);
    setResponse(null);
    let pageSizeChangedByUser = getPageSize("Receipt");
    setPageSize(pageSizeChangedByUser);
    try {
      const res = await getReceipts(
        PageNum,
        pageSizeChangedByUser,
        search,
        orderBy.length == 0 ? null : orderBy.join(","),
        filterlist
      );
      setResponse(res);
      setPages(
        res.TotalRecords > pageSizeChangedByUser
          ? Math.ceil(res.TotalRecords / pageSizeChangedByUser)
          : 1
      );
      setMessageType("info");
    } catch (error) {
      setMessageType("error");
    }
    setLoading(true);
  }

  useEffect(() => {
    getReceiptsAsync();
  }, [forceUpdate, search, orderBy, filterlist]);

  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
      getReceiptsAsync();
    }
  }, [resetForm]);

  return (
    <>
      {showAttachment && (
        <ModalForm
          modalHeight={60}
          mode={mode}
          title="Attachment"
          onHide={() => {
            setShowAttachment(false);
          }}
          show={showAttachment}
        >
          <Attachment
            baseURL={TREASURY_AND_ACCOUNTING_URL}
            onHide={() => {
              setShowAttachment(false);
              setForceUpdate(!forceUpdate);
            }}
            mood={mode}
            endpoint={
              ENDPOINTSTREASURYANDACCOUNTING.Treasury.Receipt.attachment
            }
            ownerId={selectedObj.Id}
          />
        </ModalForm>
      )}
      {showEventForm ? (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowEventForm(false);
          }}
          show={showEventForm}
          title={"Receipt"}
        >
          <ReceiptForm
            mode={mode}
            selectedObj={selectedObj}
            relod={() => setForceUpdate(!forceUpdate)}
            showForm={() => {
              setShowEventForm(false);
            }}
          />{" "}
        </ModalForm>
      ) : null}
      <div className="cartable-action">
        <Toolbar
          warehouse={false}
          remove={true}
          handleSearch={SearchHandler}
          id={selectedObj?.Id}
          emptyList={response?.TotalRecords == 0}
          create={true}
          edit={true}
          search={true}
          handleClickToolbar={clickToolbarCallback}
          attach={true}
        />
        <div
          className="card"
          style={{
            overflowY: "auto",
             height: "74vh",
            scrollbarWidth: "thin",
          }}
        >
          <div className="">
            {loading ? (
              <>
                {response?.Data?.length > 0 ? (
                  <>
                    <DataGrid
                      parentName={"Receipt"}
                      handlefiltering={(str) => {
                        setFilterlist(str);
                      }}
                      filterStr={filterlist}
                      orderFormat={setOrderBy}
                      orderFormatList={orderBy}
                      startIndex={1}
                      theadData={Object.keys(response.Data[0])}
                      tbodyData={response.Data}
                      minCellWidth={80}
                      selectedRowObjectCallback={selectedObjCallback}
                      handleEdit={handleEditRow}
                      handleDelete={(e) => {
                        // Toast(
                        //   trans("msg_deleteconfirm"),
                        //   "warning",
                        //   "alert",
                        //   handleDeleteRow
                        // );
                        Toast(
                          trans("msg_deleteconfirm"),
                          MessageType.confirmDelete,
                          handleDeleteRow
                        );
                      }}
                      handleView={handleViewRow}
                      totalRecords={response.TotalRecords}
                      pageNum={pageNum}
                      pageSize={pageSize}
                      HandleNextPage={handleNextPage}
                      HandlePrevPage={handlePrevPage}
                      handlechangePageSize={handleChangePageSize}
                      first={() => {
                        getReceiptsAsync(pages);
                        setPageNum(pages);
                      }}
                      end={() => {
                        getReceiptsAsync(1);
                        setPageNum(1);
                      }}
                      handleGoPage={handleGoPage}
                    />
                  </>
                ) : (
                  <Message message={"NoDataForPreview"} type={messageType} />
                )}
              </>
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
